
// 公共方法
import { Toast, Indicator } from 'mint-ui'
import { Message } from 'element-ui'
import store from "../../../src/store"

// 封装toast
var showToast = function (msg) {
  Toast({
    message: msg,
    duration: 1000
  });
}

var showLoading = function (msg) {
  if (!msg) {
    Indicator.open()
  } else {
    Indicator.open(msg)
  }
}

var hideLoading = function () {
  Indicator.close()
}

var showMsg = function (msg, type) {
  Message({
    type: type ? type : 'info',
    message: msg,
    center: true
  });
}

// 本地存储企业级用户信息
var localUserInfo = {
  setItem: function (data) {
    localStorage.setItem('eUserInfo', JSON.stringify(data))
  },
  getItem: function () {
    return JSON.parse(localStorage.getItem('eUserInfo'))
  },
  removeItem: function () {
    localStorage.removeItem('eUserInfo')
  }
}

/**
 * 更新面包屑内容
 * @param {*} n 更新类型 2为全部更新，3为局部更新
 * @param {*} newVal 本地存储的数据
 */
function updataBreadCrumb(n, newVal) {
  // console.log('newVal', n, newVal)
  if (n === 2) {
    // 更新所有
    sessionStorage.setItem('navBarActive', JSON.stringify(newVal))
  } else {
    // 更新3级或3级以上，更新部分
    let navBarActive = JSON.parse(sessionStorage.getItem('navBarActive')).concat(newVal)
    // console.log('nav', navBarActive)
    sessionStorage.setItem('navBarActive', JSON.stringify(navBarActive))
  }
  // 当不是导航栏的菜单，清空defaultActive
  if (getBreadCrumb().length < 1) {
    // console.log('1515', '')
    store.state.defaultActive = ''
  }
}

/**
 * 获取面包屑内容
 */
function getBreadCrumb () {
  return JSON.parse(sessionStorage.getItem('navBarActive'))
 }

 
/**
 * 本地存储数据 storage
 * sessionStorage  临时存储，在关闭窗口或标签页之后将会删除这些数据
 * localStorage    没有过期时间，直至手动删除
 */
let storage = {
  sessionSetItem: function (key, value) {
    sessionStorage.setItem(key, JSON.stringify(value))
  },
  sessionGetItem: function (key) {
    return JSON.parse(sessionStorage.getItem(key))
  },
  sessionRemoveItem: function (key) {
    sessionStorage.removeItem(key)
  },

  /* 永久存储 */
  localSetItem: function (key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  },
  localGetItem: function (key) {
    return JSON.parse(localStorage.getItem(key))
  },
  localRemoveItem: function (key) {
    localStorage.removeItem(key)
  },
}


/*  检查数组是否有重复的数据 */
function isRepeat(arr){
  var hash = {};
  for (var i in arr) {
    if (hash[arr[i].box_number])
      return true;
    hash[arr[i].box_number] = true;
  }
  return false;
}

/* 深拷贝对象 */
function deepCopy(data) {
  return JSON.parse(JSON.stringify(data))
}

/**获取当前日期
 * 格式为YYYY - MM - DD
 *
 * @returns
 */
function getNowDate(time, full) {
  var d = new Date(time);
  var mouth = d.getMonth() + 1
  var date = d.getFullYear() + '-' + (mouth < 10 ? '0' + mouth : mouth) + '-' + (d.getDate() < 10 ? '0' + d.getDate() : d.getDate())
  var datatime = d.getFullYear() + '-' + (mouth < 10 ? '0' + mouth : mouth) + '-' + (d.getDate() < 10 ? '0' + d.getDate() : d.getDate()) + ' ' + (d.getHours() < 10 ? '0' + d.getHours() : d.getHours()) + ':' + (d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes())
  var value = full ? datatime : date
  return value
}


/** 动态获取titleicon */
function setLogoTitle(rel, title) {
  // console.log('store.state.currentServerInfo', store.state.currentServerInfo)
  let currentServerInfo = store.state.currentServerInfo
  var links = document.getElementsByTagName('link')
  for (var i in links) {
    if (links[i].rel == 'shortcut icon')  {
      links[i].href = rel ? rel : (localUserInfo.getItem() && localUserInfo.getItem().logo_url != '') ? localUserInfo.getItem().logo_url : currentServerInfo.logoUrl
     }
  }
  // console.log('tag', window.location)
  // if (window.location.href.indexOf('/Exp/') !== -1) {
  // 	document.title = '极酷物联平台'
  // 	return
  // }
  if (window.location.href.indexOf('/PhonePage/') !== -1) {
    return
  }
  document.title = title ? title : localUserInfo.getItem() ? localUserInfo.getItem().company_name : currentServerInfo.title
}

/** 根据设备类型获取设备icon */
function setDeviceIcon(type) {
  let iconNum = 
              type === 'ACCESS' ? 8 :   // 门禁
              type === 'ELECTRICMETER' ? 11 :  // 电表
              type === 'TURN' ? 13 :   //周转柜
              type === 'MAGICCUBE' ? 9 :  // 魔方柜
              type === 'WAREHOUSE' ? 5 :  // RFID无人仓
              type === 'INVENTORYROBOT' ? 3 :  // 盘点机器人
              type === 'TOOL' ? 14 :   // RFID工具柜
              type === 'ESTAND' ? 1 :  // E站
              // type === 'EPSENSOR' ? 16 :  // 环境传感器
              type === 'MULTIWAREHOUSE' ? 18 :  // 医疗结算平台
              type === 'NODOORWAREHOUSE' ? 15 : // RFID盘点通道
              type === 'MULTIRESTAND' ? 17 :   // 线边仓
              type === 'DEPOSIT' ? 19 :  // 寄存柜
              type === 'IOTLETTERBOX' ? 6 :  // 物联信报箱
              type === 'SOCKET' ? 10 :  // 插座
              type === 'WATERMETER' ? 12 :  //水表
              type === 'SAFEEXPRESS' ? 20 : // 移动快递保密柜
              type === 'MEDITOOL' ? 20 : // 医疗仓
              type === 'KEYBOX' ? 22 :   // 钥匙柜
              type === 'CONDITIONER' ? 23 :   // 空调控制器
              type === 'CHECKSLAB' ? 24 :   // 盘点平板终端
              type === 'SELLBOX' ? 25 :   //智能售卖柜
              type === 'FEIBIFACE' ? 26 :  // 猫瞳人脸门禁
              type === 'CPL' ? 27 :  // 车位锁
              type === 'FRESSBOX' ? 28 :  // 生鲜柜
              type === 'WATERLEAKAGE' ? 29 :  // 漏水传感器
              type === 'EPSENSOR' ? 30 :  // 温湿度采集器
              type === 'THAIO' ? 31 :  // 消毒一体机
              type === '5' ? 32 :  // ONENET
              type === 'SECRECY' ? 33 :  // 密码保险柜
              type === '6' ? 34 :  // 云视频
              ''
  let val = 'icon_' + iconNum + '.png'
  return val
}


/**加法函数，用来得到精确的加法结果
 * 说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
 * 调用：accAdd(arg1,arg2)
 * @return arg1加上arg2的精确结果
 */
function accAdd(arg1, arg2) {
  var r1, r2, m;
  try { r1 = arg1.toString().split(".")[1].length } catch (e) { r1 = 0 }
  try { r2 = arg2.toString().split(".")[1].length } catch (e) { r2 = 0 }
  m = Math.pow(10, Math.max(r1, r2));
  return (arg1 * m + arg2 * m) / m;
}


function consoleLog(param, data) {
  console.log(param, data)
}

export {
  showToast,
  showLoading,
  hideLoading,
  showMsg,
  localUserInfo,
  updataBreadCrumb,
  getBreadCrumb,
  storage,
  isRepeat,
  deepCopy,
  getNowDate,
  setLogoTitle,
  setDeviceIcon,
  accAdd,
  consoleLog
}


//////////////////
// WEBPACK FOOTER
// ./static/js/utility/utility.js
// module id = Omly
// module chunks = 1